
import React, { useEffect, useState, Component } from 'react';
import { render } from 'react-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import CategoryComboBox from '../common/CategoryComboBox';

let resolve;

const classNames = mergeStyleSets({
    dialogContent: {
    }
});

const DialogContent = (props) => {

    const [value, setValue] = useState(props.selectedCategory);

    useEffect(() => {
        if (props.onChangeCategory) {
            props.onChangeCategory(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChangeCategory = (category) => {
        setValue(category);
    }

    return (
        <div className={classNames.dialogContent}>
            <CategoryComboBox
                categories={props.categories}
                onChangeCategory={handleChangeCategory}
                selectedCategory={props.selectedCategory}
            />
        </div>
    );
}

class DialogSelectCategory extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogSelectCategory />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            selectedCategory: null,
            categories: []
        };
    }

    checkValues() {
        let warnings = [];
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                selectedCategory: `${this.state.listName}:${this.state.selectedCategory}`
            });
        }
    }

    handleChangeCategory = (category) => {
        this.setState({
            selectedCategory: category
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Výběr kategorie parcel"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContent
                        categories={this.state.categories}
                        selectedCategory={this.state.selectedCategory}
                        onChangeCategory={this.handleChangeCategory}
                    />
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Vybrat" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(categories, actualCategoryFullName, listName) {
        this.setState({
            hidden: false,
            categories: categories,
            actualCategoryFullName: actualCategoryFullName,
            listName: listName,
            selectedCategory: actualCategoryFullName.split(':')[1]
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogSelectCategory.create();
